import React, { Component } from 'react';
import API from '../../utils/API';
import SaveBar from './components/SaveBar';

const DEFAULT = {
	firstName: '',
	lastName: '',
	contactName: '',
	companyName: '',
	phone: '',
	title: '',
	email: '',
	signerLocation: '',
	address: {
		country: 'US',
		state: '',
		city: '',
		zipCode: ''
	}
};

class PlannerInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: { ...DEFAULT, ...(props.request?.plannerInfo || {}), address: { ...DEFAULT.address, ...(props.request?.plannerInfo?.address || {}) } },
			editing: false,
			saving: false
		};
	}

	update = (field, value) => {
		this.setState((s) => ({ data: { ...s.data, [field]: value }, editing: true }));
	};

	updateAddress = (field, value) => {
		this.setState((s) => ({
			data: { ...s.data, address: { ...s.data.address, [field]: value } },
			editing: true
		}));
	};

	save = async () => {
		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/proposal-requests/${this.props.requestId}`,
				{ plannerInfo: this.state.data }
			);
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (e) {
			console.error('Error saving planner info:', e);
			this.setState({ saving: false });
		}
	};

	cancel = () => {
		const p = this.props.request?.plannerInfo || {};
		this.setState({
			data: { ...DEFAULT, ...p, address: { ...DEFAULT.address, ...(p.address || {}) } },
			editing: false
		});
	};

	render() {
		const { data, editing, saving } = this.state;
		const { request } = this.props;
		const addr = data.address || {};

		return (
			<>
				{/* ── Contact Details ───────────────────────────────── */}
				<h2 className="pr-subsection-title" style={{ marginTop: 0 }}>Contract Signee</h2>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">First Name</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.firstName || ''}
							onChange={(e) => this.update('firstName', e.target.value)}
							placeholder="First name"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Last Name</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.lastName || ''}
							onChange={(e) => this.update('lastName', e.target.value)}
							placeholder="Last name"
						/>
					</div>
				</div>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">Title</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.title || ''}
							onChange={(e) => this.update('title', e.target.value)}
							placeholder="Event Manager, Director of Events…"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Company Name</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.companyName || ''}
							onChange={(e) => this.update('companyName', e.target.value)}
							placeholder="Company or organization"
						/>
					</div>
				</div>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">Email</label>
						<input
							className="pr-text-input"
							type="email"
							value={data.email || ''}
							onChange={(e) => this.update('email', e.target.value)}
							placeholder="planner@company.com"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Phone</label>
						<input
							className="pr-text-input"
							type="tel"
							value={data.phone || ''}
							onChange={(e) => this.update('phone', e.target.value)}
							placeholder="(555) 123-4567"
						/>
					</div>
				</div>

				<div className="pr-field-group">
					<label className="pr-field-label">Signer Location</label>
					<input
						className="pr-text-input"
						type="text"
						value={data.signerLocation || ''}
						onChange={(e) => this.update('signerLocation', e.target.value)}
						placeholder="e.g., Dallas, TX"
					/>
				</div>

				{/* ── Address ───────────────────────────────────────── */}
				<h2 className="pr-subsection-title">Mailing Address</h2>

				<div className="pr-field-group compact">
					<label className="pr-field-label">Country</label>
					<input
						className="pr-text-input"
						type="text"
						value={addr.country || ''}
						onChange={(e) => this.updateAddress('country', e.target.value)}
						placeholder="US"
					/>
				</div>

				<div className="pr-row-3">
					<div className="pr-field-group compact">
						<label className="pr-field-label">City</label>
						<input
							className="pr-text-input"
							type="text"
							value={addr.city || ''}
							onChange={(e) => this.updateAddress('city', e.target.value)}
							placeholder="San Francisco"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">State / Province</label>
						<input
							className="pr-text-input"
							type="text"
							value={addr.state || ''}
							onChange={(e) => this.updateAddress('state', e.target.value)}
							placeholder="CA"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Zip / Postal Code</label>
						<input
							className="pr-text-input"
							type="text"
							value={addr.zipCode || ''}
							onChange={(e) => this.updateAddress('zipCode', e.target.value)}
							placeholder="94102"
						/>
					</div>
				</div>

				<SaveBar
					editing={editing}
					saving={saving}
					onSave={this.save}
					onCancel={this.cancel}
					updatedAt={request?.updatedAt}
				/>
			</>
		);
	}
}

export default PlannerInfo;
